class ImageSwiper extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    this.initSwiper();
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }

  initSwiper() {
    if (this.swiper) return;

    this.swiper = new Swiper(this.querySelector(".swiper"), {
      loop: true,
      slidesPerView: 1.2,
      spaceBetween: 8,

      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      },
      
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        type: "fraction",
      },

      breakpoints: {
        768: {
          slidesPerView: 2.2,
          spaceBetween: 8,
        },
        1024: {
          slidesPerView: 2.4,
          spaceBetween: 8,
        },
      },
    });
  }
}

customElements.define("image-swiper", ImageSwiper);